import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fc986d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "companyContent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "moveTo" }, "Velg firma:", -1))
const _hoisted_3 = {
  key: 0,
  class: "companyContainer"
}
const _hoisted_4 = ["onClick"]

import { ref, watch } from 'vue';
import APIServices from '@/services/apiFetch';
import CompanyType from '@/typings/Company/company';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchAndSelect',
  emits: ['setCompany'],
  setup(__props, { emit }) {

const searchQuery = ref('');
let fetchedCompanies = ref<CompanyType.Company[]>();

// eslint-disable-next-line no-undef


let throttleDelay = -1;
const throttleDelayMs = 500;

// TODO: change to computed?
watch(searchQuery, () => {
  if (throttleDelay > -1) {
    window.clearTimeout(throttleDelay);
  }

  if (searchQuery.value.length === 0) {
    fetchedCompanies.value = undefined;
    return;
  }

  throttleDelay = window.setTimeout(async () => {
    fetchedCompanies.value = await APIServices.fetchCompanyBySearchQuery(searchQuery?.value);
  }, throttleDelayMs);
});

const clearInput = function () {
  fetchedCompanies.value = undefined;
  searchQuery.value = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      class: "searchCompany",
      type: "text",
      placeholder: "Søk etter firma..",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event))
    }, null, 512), [
      [_vModelText, searchQuery.value]
    ]),
    (_unref(fetchedCompanies))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fetchedCompanies), (company) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "fetchedCompany",
              key: company?.id,
              onClick: ($event: any) => {
          emit('setCompany', company?.id, company?.name);
          clearInput();
        }
            }, _toDisplayString(company?.name), 9, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})